import { makeImmutable, Quantity, randomUUID } from "../core";
import { ProductInstanceTrackingId, } from "../ordering";
export class PProductCardCreatorInput {
    constructor(params) {
        this.productInstance = params.productInstance;
        this.quantity = params.quantity;
        this.trackingId = params.trackingId;
        this.openIntent = params.openIntent;
        makeImmutable(this);
    }
    static addFromMenu(productInstance) {
        return new PProductCardCreatorInput({
            productInstance,
            quantity: Quantity.One,
            trackingId: new ProductInstanceTrackingId(randomUUID()),
            openIntent: "add_from_menu",
        });
    }
    static addFromMenuSearch(productInstance) {
        return new PProductCardCreatorInput({
            productInstance,
            quantity: Quantity.One,
            trackingId: new ProductInstanceTrackingId(randomUUID()),
            openIntent: "add_from_menu_search",
        });
    }
    static addFromCart(productInstance) {
        return new PProductCardCreatorInput({
            productInstance,
            quantity: Quantity.One,
            trackingId: new ProductInstanceTrackingId(randomUUID()),
            openIntent: "add_from_cart",
        });
    }
    static editFromCart(orderLine) {
        return new PProductCardCreatorInput({
            productInstance: orderLine.productInstance,
            quantity: orderLine.quantity,
            trackingId: orderLine.trackingId,
            openIntent: "edit_from_cart",
        });
    }
}
